/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as o}from"../../../../webgl/Uniform.js";class r extends o{constructor(o,r,s,t){super(o,"float",0,(r,e)=>r.setUniform1fv(o,s(e),t),r)}}export{r as FloatsBindUniform};
